<template>

  <li>

    <input v-bind:disabled="medium.disabled" v-model="medium.selected"
      v-bind:id="medium.name" type="checkbox">
    <label
      v-bind:class="{ 'dps-disabled': medium.disabled, 'dps-highlight': medium.aggregated, 'dps-active': medium.selected }"
      v-bind:for="medium.name">
      {{ medium.name }}
    </label>

    <div v-show="medium.selected" class="dps-box">
      <div class="dps-input-group">
        <input min="0" placeholder="Visningar mobil" class="dps-input"
          step="1000" v-model.number="medium.mob_imp" type="number" />
        <input min="0" placeholder="Visningar desktop" class="dps-input"
          step="1000" v-model.number="medium.dtp_imp" type="number" />
      </div>
    </div>

  </li>

</template>

<script>

export default {

  name: 'medium-item',

  props: {
    medium: {
      type: Object,
      required: true
    },
    onSelected: {
      type: Function,
      required: true
    }
  },

  watch: {

    'medium.selected': function (oldValue, newValue) {
      this.onSelected(this.medium)
    }

  },

  data () {
    return {}
  }

}

</script>

<style>

.dps-input-group {
  display: flex;
  justify-content: space-between;
}

.dps-input {
  padding: 4px;
  border-radius: 2px;
  border: 1px solid #e6e6e6;
  outline: none;
  height: 15px;
  width: 45%;
  font-size: 12px;
}

.dps-box {
	position: relative;
	background: #feffeb;
	border: 1px solid #d9dabd;
  padding: 10px;
  width: 80%;
  margin: 10px;
}

.dps-box:after, .dps-box:before {
	bottom: 100%;
	left: 10%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.dps-box:after {
	border-color: rgba(136, 183, 213, 0);
	border-bottom-color: #feffeb;
	border-width: 5px;
	margin-left: -5px;
}

.dps-box:before {
	border-color: rgba(194, 225, 245, 0);
	border-bottom-color: #d9dabd;
	border-width: 6px;
	margin-left: -6px;
}

</style>



// WEBPACK FOOTER //
// src/components/MediumItem.vue